module.exports = __webpack_public_path__ + "img/Introduction_picture02.ad3d5988.jpg";